import React, { Component } from "react";
import { translate } from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../generics/WaitingModal';
import swal from 'sweetalert';
import TableValidation from './components/TableValidation';
import $ from 'jquery';
import Help from '../generics/help';

window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');
var Config = require('../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";

var Config = require('../../config');

class ValidationDonation extends Component {
  constructor(props, context) {
    super(props);

    this.getItems = this.getItems.bind(this);

    var aux_date = new Date();
    //Definicion de variables
    this.state = {
      today:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      start_date:"",
      end_date:"",
      filterText:"",
      items:[],
      filter_type:"pending",
      filters:[{key:"all", value:"TODOS"}, {key:"pending",value:"PENDIENTES VALIDAR"}, {key:"reject",value:"RECHAZADOS"}, {key:"discrepant",value:"DISCREPANTES"}],
      start_folio:"",
      end_folio:"",
      flag_init:false,
      sections:[],
      convoke_places:[],
      convoke_places_id:"all",
      patient: false
    };
  }

  componentDidMount(){
    if(this.props.location.pathname === '/validation_donation/patient'){
      this.setState({patient: true});
    }else{
      this.setState({patient:false})
    }
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  componentWillMount() {
    setTimeout(function() { //Start the timer
      this.getItems();
    }.bind(this), 100)

    //Actualizar listado por mensaje del servidor
    _hub = $.hubConnection(ChatUrl, {
      useDefaultPath: false
    });

    ChatProxy = _hub.createHubProxy('ChatHub');
    ChatProxy.getItems = this.getItems;

    ChatProxy.on("addNewMessageToPage", function(name, message) {
      if(message === "refresh_validation_list" && window.location.hash === '#/validation_donation'){
        this.getItems();
        console.log('llamando desde '+window.location.hash);
      }
    });

    _hub.start()
    .done(function() {
      console.log("Connected to Signalr Server");
    })
    .fail(function() {
      console.log("failed in connecting to the signalr server");
    });


    fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
        method: 'get',
        headers: new Headers({
           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
           'Accept': 'application/json',
            'Content-Type': 'application/json',
        })
    })
    .then(response => response.json())
    .then(response => {
      var aux = response.split('|');
      var date = aux[0].split("/");
      this.setState({
        start_date:date[2]+'-'+date[1]+'-'+date[0],
        end_date:date[2]+'-'+date[1]+'-'+date[0]
      });
    })

    fetch(Config.default.apiGateway.URL+'convoke_places?option=active',{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
          'Content-Type': 'application/json',
      })
    })
    .then(res => {
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(result) {
              swal('¡Error', result, 'error');
            });
        }})
    .then(response => {
      this.setState({
          convoke_places: response
        });
    })
    
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  handleUserInput(filterText) {
    this.setState({filterText: filterText});
  };

  componentDidUpdate() {
  }

  getItems(){
    var aux_url = "";
    
    if(this.state.start_date === "" && this.state.end_date === "" && this.state.start_folio === "" && this.state.end_folio ===""){//Inicialmente cargar la tabla con los registros del dia
      
      aux_url = "donations?option=validation&health_facilities_id="+sessionStorage.getItem("health_facilities_id")
        +"&start_date="+this.state.today+"&end_date="+this.state.today+"&start_folio="+this.state.start_folio+"&end_folio="+this.state.end_folio
        +"&filter="+this.state.filter_type+"&convoke_places_id="+this.state.convoke_places_id;
      if(this.state.patient){
        aux_url = 'samples/from_patient_validation?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
          '&start_date='+this.state.today+'&end_date='+this.state.today+'&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio+
          '&filter='+this.state.filter_type+'&convoke_places_id='+this.state.convoke_places_id;
      }
    }else{//Busqueda con filtros establecidos por el usuario
      aux_url = "donations?option=validation&health_facilities_id="+sessionStorage.getItem("health_facilities_id")
        +"&start_date="+this.state.start_date+"&end_date="+this.state.end_date+"&start_folio="+this.state.start_folio+"&end_folio="+this.state.end_folio
        +"&filter="+this.state.filter_type+"&convoke_places_id="+this.state.convoke_places_id;

      if(this.state.patient){
        aux_url = 'samples/from_patient_validation?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
          '&start_date='+this.state.start_date+'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio+
          '&filter='+this.state.filter_type+'&convoke_places_id='+this.state.convoke_places_id;
      }


      if(this.state.start_date === "" && this.state.end_date === "" && this.state.start_folio === "" && this.state.end_folio ===""){
        swal("¡Atención!", "Debe ingresar al menos un parámetro de búsqueda", 'warning');
        return;
      }

      //Validar fecha inicial < fecha final
      if(this.state.start_date !== "" && this.state.end_date !==""){
        if(this.state.start_date > this.state.end_date){
          swal("¡Atención!", "La fecha inicial no puede ser mayor a la fecha final", 'warning');
          return;
        }
      }

      //Validar folio inicial < folio final
      if(this.state.start_folio !== "" && this.state.end_folio !==""){
        if(this.state.start_folio > this.state.end_folio){
          swal("¡Atención!", "El folio inicial no puede ser mayor al folio final", 'warning');
          return;
        }
      }
    }
    if(this.waiting_modal !== null){
      this.waiting_modal.handleShow('Cargando...');
    }
    fetch(Config.default.apiGateway.URL+aux_url,{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
          'Content-Type': 'application/json',
      })
    })
    .then(res => {
      if(this.waiting_modal !== null){
        this.waiting_modal.handleClose();
      }
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(error) {
              swal('¡Error', error, 'error');
            });
        }
    })
    .then(response => {
      if(response !== undefined){
        if(response.length > 0){
          if(response[0].sections_color.length > 0){

            var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
            var sections = [];

            lab_sections.map((s)=>{
              if(s.validate_results){
                var indexSection = response[0].sections_color.findIndex((obj => obj.lab_section_id === s.lab_sections_id));
                if(indexSection !== -1){
                  sections.push(
                    response[0].sections_color[indexSection]
                  )                
                }
                  
              }
            })
            
            this.setState({ items: response, sections: sections });

            this.table.paginator(response);
          }else{
            this.setState({ items: [], sections:[] });
            this.table.paginator([], 0);
          }
        }else{
          this.setState({ items: [], sections:[] });
            this.table.paginator([], 0);
        }
      }
    })
  }

  //Contenido de la pantalla Listado
  render() {
    const { t } = this.props;

    return (
      <div className="col-xs-12">
        <div className="route">
          <h5 className="title_page" >
            {sessionStorage.getItem('health_facilities_name')} ->
            {t('sidebar.nav.laboratory.MAIN')} -> 
            {t('sidebar.nav.laboratory.validation_donation')}
          </h5>
        </div>
        
        <Help 
            {...this.props}
            menu={"help_laboratory"} 
            submenu={"help_cascade_validation"}  />
        <div className="form-group" style={{paddingTop:"10px"}}>
          
          {/*<div className="col-xs-12 col-md-2" >
            <SearchBar filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)}/>
          </div>*/}

          <div className="col-xs-12 col-md-2">
            <span className="span-min">{t('content.validation_donation.start_date')+':'}</span>
            <input className="form-control" type="date" value={this.state.start_date} name="start_date" onChange={ this.handleChange}/>
          </div>
          <div className="col-xs-12 col-md-2">
            <span className="span-min">{t('content.validation_donation.end_date')+':'}</span>
            <input className="form-control" type="date" value={this.state.end_date} name="end_date" onChange={ this.handleChange}/>
          </div>

          <div className="col-xs-12 col-md-1">
            <span className="span-min">{t('content.validation_donation.start_folio')+':'}</span>
            <input className="form-control" type="text" value={this.state.start_folio} name="start_folio" onChange={ this.handleChange}/>
          </div>

          <div className="col-xs-12 col-md-1">
            <span className="span-min">{t('content.validation_donation.end_folio')+':'}</span>
            <input className="form-control" type="text" value={this.state.end_folio} name="end_folio" onChange={ this.handleChange}/>
          </div>

          <div className="col-xs-12 col-sm-2">
							<span className="span-min">{t('content.offers.form.convoke_place')}</span>
							<select className="form-control" 
				             	value={ this.state.convoke_places_id || "" } onKeyPress={(e) => this.props.validate(e)}
                       onChange={ this.handleChange} name="convoke_places_id" id="convoke_places_id" >
                        <option value="all" key="all">TODOS</option>
				                {
				                this.state.convoke_places.map(function(t) {
				                  return <option key={t.convoke_places.id}  value={t.convoke_places.id} >{t.convoke_places.name} </option>;
				                })
				            }
              </select>
          </div>	

          <div className="col-xs-12 col-md-2" style={{paddingTop:"20px"}}> 
            <select className="form-control" onChange={ this.handleChange }
                value={ this.state.filter_type || "" } 
                  name="filter_type" id="filter_type" >
                  {
                  this.state.filters.map(function(t) {
                    return <option key={t.key}  value={t.key} >{t.value} </option>;
                  })
              }
            </select>
          </div>

          <div className="col-xs-12 col-sm-1 form-group" style={{paddingTop:"12px"}}>
            <button style={{float:"right", fontSize:"1em"}} className="btn btn-info" type="button" onClick={(e) => this.getItems()}>
              {t('content.generics.buttons.search')}
            </button>
          </div>

        </div>
        
        <div className="col-xs-12">
            <TableValidation filterDate={this.state.start_date} filterText={this.state.filterText} {...this.props} onRef={ref => (this.table = ref)} 
              items={this.state.items} 
              search={this.props.search} 
              refresh={this.getItems}
              state={this.state}
              />
        </div>
        <Notifications />
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
      </div>
    );
  }
}

export default translate('translations')(ValidationDonation)